import { render, staticRenderFns } from "./client-profile-container.vue?vue&type=template&id=1a63834c&scoped=true"
import script from "./client-profile-container.vue?vue&type=script&lang=js"
export * from "./client-profile-container.vue?vue&type=script&lang=js"
import style0 from "./client-profile-container.vue?vue&type=style&index=0&id=1a63834c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a63834c",
  null
  
)

export default component.exports